"use client"

import {
  AskLeoButton as PackageAskLeoButton,
  type AskLeoButtonProps as PackageAskLeoButtonProps,
} from "@exxatdesignux/ui/components/shell/ask-leo-button"

import { AskLeoShortcutKbds, useAskLeo } from "@/components/ask-leo-context"

export interface AskLeoButtonProps
  extends Omit<PackageAskLeoButtonProps, "onClick" | "shortcut"> {
  /** Overrides the global sidebar toggle for route-local Leo actions. */
  onClick?: () => void
  /** When false, the tooltip omits the global Ask Leo shortcut. */
  showShortcut?: boolean
}

/**
 * App binding for the package-owned Ask Leo action.
 *
 * The package owns every visual and interaction state. This shim only connects
 * the global sidebar action and the app's platform-aware shortcut label.
 */
export function AskLeoButton({
  onClick,
  showShortcut = true,
  ...props
}: AskLeoButtonProps) {
  const { toggle } = useAskLeo()

  return (
    <PackageAskLeoButton
      {...props}
      onClick={onClick ?? toggle}
      shortcut={showShortcut ? <AskLeoShortcutKbds /> : undefined}
    />
  )
}
